import React from 'react';
import {
  SiWhatsapp,
  SiInstagram,
  SiTelegram,
  SiFacebook,
} from 'react-icons/si';
import { MessageCircle } from 'lucide-react';

const channels = [
  { name: 'WhatsApp', Icon: SiWhatsapp, color: '#25D366' },
  { name: 'Instagram', Icon: SiInstagram, color: '#E4405F' },
  { name: 'Telegram', Icon: SiTelegram, color: '#26A5E4' },
  { name: 'Facebook', Icon: SiFacebook, color: '#1877F2' },
  { name: 'Web Chat', Icon: MessageCircle, color: '#06b6ec' },
];

export default function ChannelsStrip() {
  return (
    <section id="channels" className="strip">
      <div className="container">
        <p className="strip__label">Connect every channel your customers chat on</p>
        <div className="strip__row">
          {channels.map(({ name, Icon, color }) => (
            <div key={name} className="strip__item">
              <span className="strip__icon" style={{ color }} aria-hidden="true">
                <Icon size={18} />
              </span>
              <span className="strip__name">{name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
